import { render, staticRenderFns } from "./CustomerDetails.component.html?vue&type=template&id=746db550&scoped=true&"
import script from "./CustomerDetails.component.ts?vue&type=script&lang=ts&"
export * from "./CustomerDetails.component.ts?vue&type=script&lang=ts&"
import style0 from "./CustomerDetails.component.scss?vue&type=style&index=0&id=746db550&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746db550",
  null
  
)

export default component.exports